export const notificationsPanelTranslations = {
    en: {
        NOTIFICATIONS_PANEL_TITLE: 'Notifications',
        NOTIFICATIONS_EMPTY: 'No notifications',
        NOTIFICATIONS_EMPTY_SUB: 'There\'s no notifications now',
        NOTIFICATIONS_CLOSE: 'Close',
        NOTIFICATIONS_CLOSE_ALL: 'Close all',
        NOTIFICATIONS_SHOW_MORE: 'Show more'
    },
    ru: {
        NOTIFICATIONS_PANEL_TITLE: 'ÐÐ¿Ð¾Ð²ÐµÑÐµÐ½Ð¸Ñ',
        NOTIFICATIONS_EMPTY: 'ÐÐµÑ Ð¾Ð¿Ð¾Ð²ÐµÑÐµÐ½Ð¸Ð¹',
        NOTIFICATIONS_EMPTY_SUB: 'ÐÐ° Ð´Ð°Ð½Ð½ÑÐ¹ Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð¾Ð¿Ð¾Ð²ÐµÑÐµÐ½Ð¸Ð¹ Ð½ÐµÑ',
        NOTIFICATIONS_CLOSE: 'ÐÐ°ÐºÑÑÑÑ',
        NOTIFICATIONS_CLOSE_ALL: 'ÐÐ°ÐºÑÑÑÑ Ð²ÑÐµ',
        NOTIFICATIONS_SHOW_MORE: 'ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ ÐµÑÐµ'
    }
};
